<template>
  <div id="academic_interdisciplinary">
    <usc-hero :title="this.hero.title" :loResSrc="this.hero.loResSrc" :hiResSrc="this.hero.hiResSrc" :color="this.page.color"></usc-hero>
    <usc-intro :copy="this.intro"></usc-intro>
    <div class="body gutter-lg mb">
      <p><i>Internship courses allow students to gain real-world experience with companies such as 20th Century Fox, April Webster Casting, Columbia and Paramount Pictures, Fox Sports Networks, ICM and UTA Talent Agencies, New Line Cinema and Sony Music Entertainment.</i></p>
      <p>The BCA program provides you with specialized expertise that will distinguish you as a competitive leader in both the business and entertainment industries. BCA also offers extensive professional networking opportunities with distinguished guest speakers from the entertainment industry. Speakers discuss current trends and issues in the industry that give students insights into the future of cinema, television, the internet and other forms of media.</p>
    </div>
    <usc-table :title="this.table1.title" :data="this.table1.data" :disclaimer="this.table1.disclaimer"></usc-table>
    <usc-table :title="this.table2.title" :data="this.table2.data" :disclaimer="this.table2.disclaimer"></usc-table>
    <div class="body gutter-lg mb">
      <h2>Core Courses</h2>
      <p>In addition to Marshall core classes, BCA students take 24 units at the School of Cinematic Arts. Two lower-division courses cover the history of cinema and television, and additional courses include specialized business/entertainment topics such as entertainment marketing, agenting and film procedures and distribution.</p>
      <p>In addition to the Marshall core classes and elective courses, students complete the following:</p>
      <h4>CTCS 190: INTRODUCTION TO CINEMA (4 UNITS)</h4>
      <p>This comprehensive course analyzes the power and responsibility of American and international film and television.</p>

      <h4>CTCS 191: INTRODUCTION TO TELEVISION AND VIDEO (4 UNITS)</h4>
      <p>This class involves understanding film and television texts in relation to the world they represent, and studying not only the meaning of these texts but also the processes by which these meanings are constructed.</p>

      <h4>CTPR 410: THE MOVIE BUSINESS (2 UNITS)</h4>
      <p>This course offers a broad overview of the entertainment industry and an examination of the motion picture business from the screenwriter’s treatment through production, marketing and exhibition in theaters. Students learn about the roles played by writers, agents, studio executives and directors, as well as marketing and distribution channels.</p>

      <h4>CTPR 495: INTERNSHIP IN CINEMA-TELEVISION (2 UNITS)</h4>
      <p>Students secure an internship with a company of their choice. The company is given a USC internship contract and is required to meet specific standards that ensure an educational opportunity and beneficial work environment for the student. Class sessions focus on how to find and keep your first job and use it to your advantage, including tips on troubleshooting and how to be an assistant. Students share work-related situations and experiences.</p>

      <h4>CNTV 463 TELEVISION: INTEGRATING CREATIVE AND BUSINESS OBJECTIVES (2 UNITS)</h4>
      <p>An investigation of the creative and business sides of television and how they connect, including changes caused by fractionalization and digital technology. This course is open only to BCA students.</p>

      <h4>CNTV 467: THE FUTURE OF DIGITAL MEDIA &amp; THE ENTERTAINMENT INDUSTRY (2 UNITS)</h4>
      <p>This course examines how digital media will affect the future of the television, motion picture, game, music and interactive industries.</p>

      <h4>CTIN 458: BUSINESS &amp; MANAGEMENT OF GAMES (2 UNITS)</h4>
      <p>Providing a solid preparation for successful careers in interactive entertainment, this course covers a range of business and legal issues, including an overview of current business models for games and interactive media, methods of pitching and funding products, legal issues pertaining to copyright and intellectual property and production management techniques. Also included are business start-up basics for aspiring entrepreneurs.</p>

      <h4>CTPR 460: FILM BUSINESS PROCEDURES &amp; DISTRIBUTION (2 UNITS)</h4>
      <p>Taught by a former head of marketing at Universal who is now an independent marketing consultant, this course covers such topics as theatrical marketing, corporate partnership, television marketing and advertising.</p>

      <h4>CTPR 385: MOTION PICTURE PRODUCTION TECHNIQUES (4 UNITS)</h4>
      <p>This class covers motion picture production from scriptwriting to planning, shooting and editing. The class writes, directs and shoots a digital video.</p>
    </div>
    <usc-course-chart :dataSet="courseData">
      <img slot="image" src="../../../static/USC_Marshall_CurriculumMap_2023_BCA_R3.png" alt="Course chart for cinematic arts">
    </usc-course-chart>
  </div>
</template>

<script>
import hero from '@/components/Hero'
import intro from '@/components/Intro'
import table from '@/components/Table'
import Cta from '@/components/Cta'
import CourseChart from '@/components/CourseChart/CourseChart'

export default {
  name: 'BusinessCincematicArts',
  components: {
    'usc-hero': hero,
    'usc-intro': intro,
    'usc-table': table,
    'usc-cta': Cta,
    'usc-course-chart': CourseChart
  },
  data () {
    return {
      page: {
        color: '#ffcc00'
      },
      hero: {
        title: 'Business Cinematic Arts',
        loResSrc: '../../../static/HeroImages/Academics7.jpg',
        hiResSrc: '../../../static/HeroImages/Academics7.jpg'
      },
      intro: [
        'Leveraging our location in the world’s entertainment capital, the John H. Mitchell Business of Cinematic Arts (BCA) degree program pairs Marshall’s exceptional business curriculum with the world’s leading School of Cinematic Arts. This prestigious program is available to entering freshmen only, with space limited to 50 students per year.'
      ],
      table1: {
        title: 'BCA internships include:',
        data: [
          {
            left: '20th Century Fox',
            right: 'ABC Comedy Development'
          },
          {
            left: 'ABC/Jimmy Kimmel Live',
            right: 'Bravo'
          },
          {
            left: 'Fox Sports Networks',
            right: 'Paramount Pictures'
          },
          {
            left: 'United Talent Agency (UTA)',
            right: ''
          }
        ]
      },
      table2: {
        title: 'Full-Time Employment:',
        data: [
          {
            left: 'Creative Arts Agency (CAA)',
            right: 'William Morris Endeavor (WME)'
          },
          {
            left: 'United Talent Agency (UTA)',
            right: '20th Century Fox'
          },
          {
            left: 'Warner Bros.',
            right: 'Sony Music Entertainment'
          },
          {
            left: 'Google',
            right: 'Paramount Pictures'
          }
        ],
        disclaimer: ''
      },
      courseData: {
        title: 'USC Marshall Undergraduate Business Program',
        subtitle: 'Business Administration Cinematic Arts Emphasis—BCA Four-Year Sample Course Sequence',
        key: [
          {
            courseColor: 'marshall-core',
            courseLabel: 'Marshall Core'
          },
          {
            courseColor: 'usc-elective',
            courseLabel: 'USC Elective/Minor'
          },
          {
            courseColor: 'usc-requirement',
            courseLabel: 'USC Requirement'
          },
          {
            courseColor: 'marshall-elective',
            courseLabel: 'Marshall Elective'
          },
          {
            courseColor: 'cinematic-arts',
            courseLabel: 'Cinematic Arts'
          }
        ],
        years: {
          freshman: {
            yearTitle: 'FRESHMAN',
            semesters: {
              Fall: [
                {
                  courseID: 'Math 118',
                  courseName: 'Fundamental Principles of the Calculus',
                  courseColor: 'marshall-core',
                  hasMin: false,
                  min: 4,
                  courseCredits: 4
                },
                {
                  courseID: 'BUAD 304',
                  courseName: 'Organizational Behavior and Leadership',
                  courseColor: 'marshall-core',
                  hasMin: false,
                  min: 4,
                  courseCredits: 4
                },
                {
                  courseID: 'WRIT 150',
                  courseName: 'Writing and Critical Reasoning',
                  courseColor: 'usc-requirement',
                  hasMin: false,
                  min: 4,
                  courseCredits: 4
                },
                {
                  courseID: 'CTCS 190',
                  courseName: 'Introduction to Cinema',
                  courseColor: 'cinematic-arts',
                  hasMin: false,
                  min: 4,
                  courseCredits: 4
                }
              ],
              Spring: [
                {
                  courseID: 'ECON 351x',
                  courseName: 'Microeconomics for Business',
                  courseColor: 'marshall-core',
                  hasMin: false,
                  min: 4,
                  courseCredits: 4
                },
                {
                  courseID: 'BUAD 310 or 312',
                  courseName: 'Applied Business Statistics',
                  courseColor: 'marshall-core',
                  hasMin: false,
                  min: '4',
                  courseCredits: '4'
                },
                {
                  courseID: 'GESM',
                  courseName: 'General Education Seminar',
                  courseColor: 'usc-elective',
                  hasMin: true,
                  min: 4,
                  courseCredits: 4
                },
                {
                  courseID: 'BUAD 385',
                  courseName: 'Colloquium: Motion Picture Production Techniques',
                  courseColor: 'cinematic-arts',
                  hasMin: false,
                  min: 4,
                  courseCredits: 4
                },
                {
                  courseID: 'Optional Elective',
                  courseName: 'BUAD 104',
                  courseColor: 'marshall-core',
                  hasMin: false,
                  min: 2,
                  courseCredits: 2
                }
              ]
            }
          },
          sophmore: {
            yearTitle: 'SOPHOMORE',
            semesters: {
              Fall: [
                {
                  courseID: 'BUAD 280',
                  courseName: 'Introduction to Financial Accounting',
                  courseColor: 'marshall-core',
                  hasMin: false,
                  min: 3,
                  courseCredits: 3
                },
                {
                  courseID: 'BUAD 302',
                  courseName: 'Communication Strategy in Business',
                  courseColor: 'marshall-core',
                  hasMin: false,
                  min: 4,
                  courseCredits: 4
                },
                {
                  courseID: 'BUAD 306 or 308',
                  courseName: 'Business Finance or Advanced Business Finance',
                  courseColor: 'marshall-core',
                  hasMin: false,
                  min: 4,
                  courseCredits: 4
                },
                {
                  courseID: 'GE',
                  courseName: '',
                  courseColor: 'usc-requirement',
                  hasMin: false,
                  min: 4,
                  courseCredits: 4
                },
                {
                  courseID: 'CTPR 410',
                  courseName: 'The Entertainment Industry: From Idea to Audience',
                  courseColor: 'cinematic-arts',
                  hasMin: false,
                  min: 2,
                  courseCredits: 2
                }
              ],
              Spring: [
                {
                  courseID: 'BUAD 281',
                  courseName: 'Introduction to Managerial Accounting',
                  courseColor: 'marshall-core',
                  hasMin: false,
                  min: 3,
                  courseCredits: 3
                },
                {
                  courseID: 'ECON 352x',
                  courseName: 'Macroeconomics for Business',
                  courseColor: 'marshall-core',
                  hasMin: false,
                  min: 4,
                  courseCredits: 4
                },
                {
                  courseID: 'BUAD 307',
                  courseName: 'Marketing Fundamentals',
                  courseColor: 'marshall-core',
                  hasMin: false,
                  min: 4,
                  courseCredits: 4
                },
                {
                  courseID: 'CNTV 441',
                  courseName: 'Entertainment Practicum',
                  courseColor: 'usc-requirement',
                  hasMin: false,
                  min: 2,
                  courseCredits: 2
                },
                {
                  courseID: 'Optional Free Elective',
                  courseName: '',
                  courseColor: 'usc-elective',
                  hasMin: true,
                  min: 2,
                  courseCredits: 4
                }
              ]
            }
          },
          junior: {
            yearTitle: 'JUNIOR',
            semesters: {
              Fall: [
                {
                  courseID: 'BUAD 311 or 313',
                  courseName: 'Operations Management or Advanced Operations Management & Analytics',
                  courseColor: 'marshall-core',
                  hasMin: false,
                  min: 4,
                  courseCredits: 4
                },
                {
                  courseID: 'BUAD 497',
                  courseName: 'Strategi Management',
                  courseColor: 'marshall-core',
                  hasMin: false,
                  min: 4,
                  courseCredits: 4
                },
                {
                  courseID: 'GE',
                  courseName: '',
                  courseColor: 'usc-requirement',
                  hasMin: false,
                  min: 4,
                  courseCredits: 4
                },
                {
                  courseID: 'CNTV 463',
                  courseName: 'Television: Integrating Creative and Business Objectives',
                  courseColor: 'cinematic-arts',
                  hasMin: false,
                  min: 2,
                  courseCredits: 2
                },
                {
                  courseID: 'Free Elective',
                  courseName: '',
                  courseColor: 'usc-elective',
                  hasMin: true,
                  min: 2,
                  courseCredits: 4
                }
              ],
              Spring: [
                {
                  courseID: 'BUAD 425',
                  courseName: 'Introduction to Business Analytics',
                  courseColor: 'marshall-core',
                  hasMin: false,
                  min: 2,
                  courseCredits: 2
                },
                {
                  courseID: 'Marshall Upper Division Elective / Emphasis',
                  courseName: '',
                  courseColor: 'marshall-elective',
                  hasMin: false,
                  min: 4,
                  courseCredits: 4
                },
                {
                  courseID: 'GE',
                  courseName: '',
                  courseColor: 'usc-requirement',
                  hasMin: false,
                  min: 4,
                  courseCredits: 4
                },
                {
                  courseID: 'CTIN 428',
                  courseName: 'ET Law and Dealmaking',
                  courseColor: 'cinematic-arts',
                  hasMin: false,
                  min: 2,
                  courseCredits: 2
                },
                {
                  courseID: 'CTIN 458',
                  courseName: 'Business and Management of Games',
                  courseColor: 'cinematic-arts',
                  hasMin: false,
                  min: 2,
                  courseCredits: 2
                }
              ]
            }
          },
          senior: {
            yearTitle: 'SENIOR',
            semesters: {
              Fall: [
                {
                  courseID: 'Marshall Upper Division Elective/Empahsis',
                  courseName: '',
                  courseColor: 'marshall-elective',
                  hasMin: false,
                  min: 4,
                  courseCredits: 4
                },
                {
                  courseID: 'WRIT 340',
                  courseName: 'Advanced Writing',
                  courseColor: 'usc-requirement',
                  hasMin: true,
                  min: 3,
                  courseCredits: 4
                },
                {
                  courseID: 'GE',
                  courseName: '',
                  courseColor: 'usc-requirement',
                  hasMin: false,
                  min: 4,
                  courseCredits: 4
                },
                {
                  courseID: 'CNTV',
                  courseName: 'Producing and Marketing Feature-Length Films',
                  courseColor: 'cinematic-arts',
                  hasMin: false,
                  min: 2,
                  courseCredits: 2
                },
                {
                  courseID: 'Free Elective',
                  courseName: '',
                  courseColor: 'usc-elective',
                  hasMin: true,
                  min: 2,
                  courseCredits: 4
                }
              ],
              Spring: [
                {
                  courseID: 'Marshall Upper Division Elective/Emphasis',
                  courseName: '',
                  courseColor: 'marshall-elective',
                  hasMin: false,
                  min: 4,
                  courseCredits: 4
                },
                {
                  courseID: 'GE',
                  courseName: '',
                  courseColor: 'usc-requirement',
                  hasMin: false,
                  min: 4,
                  courseCredits: 4
                },
                {
                  courseID: 'GE',
                  courseName: '',
                  courseColor: 'usc-requirement',
                  hasMin: false,
                  min: 4,
                  courseCredits: 4
                },
                {
                  courseID: 'CNTV 481',
                  courseName: 'Hollywood Launchpad',
                  courseColor: 'cinematic-arts',
                  hasMin: false,
                  min: 4,
                  courseCredits: 4
                }
              ]
            }
          }
        }
      }
    }
  },
  created () {
    this.$root.setPageHeader('Academics', 'Business Cinematic Arts')
  }
}
</script>

<style scoped lang="scss">

</style>



// WEBPACK FOOTER //
// src/pages/academics/BusinessCinematicArts.vue